<template>
  <div>
    <el-button type="primary" @click="showDialog">洗水唛</el-button>
    <el-dialog :visible.sync="dialogVisible" title="洗水唛" class="care-label-dialog" append-to-body>
      <div ref="container" class="care-label-container">
        <Background
          :customer-name="data.customer_name"
          :number="data.number"
          :url="`${this.$root.user.host}/pages/product-designs-qrcode/detail?id=${data.id}`"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="print">打印洗水唛</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import Background from './background.vue';

@Component({
  components: {
    Background
  }
})
export default class CareLabel extends Vue {
  @Prop(Object) data;

  dialogVisible = false

  showDialog() {
    this.dialogVisible = true
  }

  print() {
    const printContent = this.$refs.container.innerHTML;
    let newWin = window.open('', 'Print-Window');
    newWin.document.open();
    newWin.document.write(`
      <html>
        <head>
          <style>
            @media print {
              @page {
                margin: 0; /* 去掉页边距 */
              }

              /* 隐藏浏览器默认的页眉和页脚 */
              @page :footer {
                display: none;
              }

              @page :header {
                display: none;
              }
            }
            @page { size: 40mm 120mm; }
            body {
              margin: 0;
              padding: 0;
              width: fit-content;
              height: fit-content;
              box-sizing: border-box;
            }
          </style>
        </head>
        <body onload="window.print()">
          ${printContent}
        </body>
      </html>
    `);
    newWin.document.close();
    setTimeout(() => newWin.close(), 10);
  }
}
</script>

<style lang="scss" scoped>
.care-label-container {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
}
</style>
